import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import formatDate, { DEFAULT_FORMAT } from "utils/formatDate";

// Actions
import { changeSelectedPeriod } from "actions/reports";

import styles from "./styles.module.css";

export default function Filters() {
    const dispatch = useDispatch();

    const selectedPeriod = useSelector(state => state.reports.catalog.selectedPeriod);
    const periods = useSelector(state => state.reports.catalog.periods);

    const changePeriod = e => dispatch(changeSelectedPeriod(e.target.value));

    if (periods && Boolean(periods.length)) {
        return (
            <select
                className={ styles.select }
                onChange={ changePeriod }
                value={ selectedPeriod }
            >
                {
                    periods.map(period => (
                        <option
                            key={ period }
                            value={ period }
                        >
                            { formatDate(period, DEFAULT_FORMAT) }
                        </option>
                    ))
                }
            </select>
        );
    }

    return null;
}
